import React from "react";
import "./faq.css";
import Qanda from "./qanda";
import Navbar from "../layouts/navbar";


export const Faq = (props) => {

  return (
    <div>
      <Navbar head="FAQ's" />
      {/* search bar start */}
      


      {/* <div class='container'>
        <form action=''>
          <div class='form-group search'>
            <input
              type='search'
              class='form-control form-control-lg  search_bar'
              placeholder='Search By Keywords'
            />
            <button type='submit' class='searchButton'>
              <i class='fas fa-search fa-lg icon' />
            </button>
          </div>
        </form>
      </div> */}
      {/* search bar end */}
      <div style={{marginTop:"50px"}}>
      <Qanda hash={props.location.hash}/>
      </div>

      

    </div>
  );
};


export default Faq;
